<template>
  <div class="card" v-show="currentCardId == 'esf-detail'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>障がい情報入力</h2>
      </div>
      <div class="card-content">
        <p style="font-size: 90%">
          <span style="color: red">※</span>手帳の種類：
        </p>
        <div style="display: inline-block; min-width: 100%; margin-bottom: 5px">
          <el-select
            v-model="formatData.handbookKind"
            placeholder="選択してください"
            @change="selectHandbookKind"
          >
            <el-option
              v-for="item in esfOptions.handbookKindOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <br />
        <p style="font-size: 90%">
          <span style="color: red">※</span>手帳の障害種類：
        </p>
        <div style="display: inline-block; min-width: 100%; margin-bottom: 5px">
          <el-select
            v-model="formatData.shogaiKind"
            placeholder="選択してください"
          >
            <el-option
              v-for="item in shogaiKindOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <br />
        <p
          v-if="formatData.shogaiKind == 'その他'"
          style="font-size: 90%; margin-bottom: 5px"
        >
          手帳の障害種類の直接入力：
        </p>
        <div
          v-if="formatData.shogaiKind == 'その他'"
          style="display: inline-block; min-width: 100%"
        >
          <p style="font-size: 100%; text-align: left">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="formatData.shogaiKind_etc"
            />
          </p>
          <p style="font-size: 77%">
            <span style="color: red"
              >※個人を特定できる情報の記載をしないでください。</span
            >
          </p>
        </div>
        <br />
        <p style="font-size: 90%">
          <span style="color: red">※</span>手帳の等級：
        </p>
        <div style="display: inline-block; min-width: 100%; margin-bottom: 5px">
          <el-select
            v-model="formatData.shogaiLevel"
            placeholder="選択してください"
          >
            <el-option
              v-for="item in shogaiLevelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <br />
        <p style="font-size: 90%; margin-bottom: 5px">
          <span style="color: red">※</span>通院の有無：
        </p>
        <div style="display: inline-block; min-width: 100%">
          <p style="font-size: 100%; text-align: left">
            <el-radio v-model="formatData.hospitalVisit" label="あり">
              あり</el-radio
            >
            <el-radio v-model="formatData.hospitalVisit" label="なし">
              なし</el-radio
            >
          </p>
        </div>
        <br />
        <p
          v-if="formatData.hospitalVisit == 'あり'"
          style="font-size: 90%; margin-bottom: 5px"
        >
          通院の頻度などの詳細：
        </p>
        <div
          v-if="formatData.hospitalVisit == 'あり'"
          style="display: inline-block; min-width: 100%"
        >
          <p style="font-size: 100%; text-align: left">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="formatData.hospitalVisitDescription"
            />
          </p>
          <p style="font-size: 77%">
            <span style="color: red">※最大3000文字まで、入力できます。</span>
          </p>
          <p style="font-size: 77%">
            <span style="color: red"
              >※個人を特定できる情報の記載をしないでください。</span
            >
          </p>
        </div>
        <br />
        <p style="font-size: 90%; margin-bottom: 5px">
          <span style="color: red">※</span>得意なこと・スキル：
        </p>
        <div style="display: inline-block; min-width: 100%">
          <p style="font-size: 100%; text-align: left">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="formatData.skillDescription"
            />
          </p>
          <p style="font-size: 77%">
            <span style="color: red">※最大3000文字まで、入力できます。</span>
          </p>
          <p style="font-size: 77%">
            <span style="color: red"
              >※個人を特定できる情報の記載をしないでください。</span
            >
          </p>
        </div>
        <br />
        <p style="font-size: 90%; margin-bottom: 5px">
          障がい特性：<el-button
            type="success"
            @click="disorderFeatureVisible = true"
            >例文から追加</el-button
          >
        </p>
        <div style="display: inline-block; min-width: 100%">
          <NewRirekishoExampleSentenceDialog
            :value="disorderFeatureVisible"
            name="disorderFeatureSample-dialog"
            :items="esfOptions.disorderFeatureStatement"
            show-overwrite-warning
            @input="disorderFeatureVisible = $event"
            @select="
              (item) =>
                (formatData.disorderFeature =
                  item.description.replace(/<br>/gi, '\n') + '\n')
            "
          />
          <p style="font-size: 100%; text-align: left">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="formatData.disorderFeature"
            />
          </p>
          <p style="font-size: 77%">
            <span style="color: red">※最大3000文字まで、入力できます。</span>
          </p>
          <p style="font-size: 77%">
            <span style="color: red"
              >※個人を特定できる情報の記載をしないでください。</span
            >
          </p>
        </div>
        <br />
        <p style="font-size: 90%; margin-bottom: 5px">
          障害特性に対する自己対処：<el-button
            type="success"
            @click="selfDisorderFeatureVisible = true"
            >例文から追加</el-button
          >
        </p>
        <div style="display: inline-block; min-width: 100%">
          <NewRirekishoExampleSentenceDialog
            :value="selfDisorderFeatureVisible"
            name="selfDisorderFeatureSample-dialog"
            :items="esfOptions.selfDisorderFeatureStatement"
            show-overwrite-warning
            @input="selfDisorderFeatureVisible = $event"
            @select="
              (item) =>
                (formatData.selfDisorderFeature =
                  item.description.replace(/<br>/gi, '\n') + '\n')
            "
          />
          <p style="font-size: 100%; text-align: left">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="formatData.selfDisorderFeature"
            />
          </p>
          <p style="font-size: 77%">
            <span style="color: red">※最大3000文字まで、入力できます。</span>
          </p>
          <p style="font-size: 77%">
            <span style="color: red"
              >※個人を特定できる情報の記載をしないでください。</span
            >
          </p>
        </div>
        <br />
        <p style="font-size: 90%; margin-bottom: 5px">
          自己対処ではカバーしきれない企業側への配慮希望：<el-button
            type="success"
            @click="considerationDesiredVisible = true"
            >例文から追加</el-button
          >
        </p>
        <div style="display: inline-block; min-width: 100%">
          <NewRirekishoExampleSentenceDialog
            :value="considerationDesiredVisible"
            name="considerationDesired-dialog"
            :items="esfOptions.considerationDesiredStatement"
            show-overwrite-warning
            @input="considerationDesiredVisible = $event"
            @select="
              (item) =>
                (formatData.considerationDesired =
                  item.description.replace(/<br>/gi, '\n') + '\n')
            "
          />
          <p style="font-size: 100%; text-align: left">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="formatData.considerationDesired"
            />
          </p>
          <p style="font-size: 77%">
            <span style="color: red">※最大3000文字まで、入力できます。</span>
          </p>
          <p style="font-size: 77%">
            <span style="color: red"
              >※個人を特定できる情報の記載をしないでください。</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import esfOptions from '@/utils/format-edit/rirekishoEsfOptions.json'

defineProps<{
  currentCardId?: string
}>()

const formatData = useRirekishoFormatData()
const shogaiKindOptions = ref(esfOptions.shogaiKindOptionTemps.first)
const shogaiLevelOptions = ref(esfOptions.shogaiLevelOptionTemps.first)
const disorderFeatureVisible = ref(false)
const selfDisorderFeatureVisible = ref(false)
const considerationDesiredVisible = ref(false)

function selectHandbookKind() {
  if (formatData.handbookKind === '身体障害者手帳') {
    shogaiKindOptions.value = esfOptions.shogaiKindOptionTemps.first
    shogaiLevelOptions.value = esfOptions.shogaiLevelOptionTemps.first
  }
  if (formatData.handbookKind === '療育手帳') {
    shogaiKindOptions.value = esfOptions.shogaiKindOptionTemps.second
    shogaiLevelOptions.value = esfOptions.shogaiLevelOptionTemps.second
  }
  if (formatData.handbookKind === '精神障害者保健福祉手帳') {
    shogaiKindOptions.value = esfOptions.shogaiKindOptionTemps.third
    shogaiLevelOptions.value = esfOptions.shogaiLevelOptionTemps.third
  }
  formatData.shogaiKind = ''
  formatData.shogaiLevel = ''
}
</script>
